import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { formatDate } from 'app/utils';
import { IWMStyle, WmTableRow } from './Wochenmail';
import { WMHeading } from './PlainTextWochenmail';

export const WochenmailJubel = observer((props: IWMStyle) => {
	const { wmStyles, isText } = props;
	const { wochenmailtUiStore } = useStore();
	const title = `Anstehende Jubiläen`;

	return (
		<>
			{wochenmailtUiStore.loaded && wochenmailtUiStore.showJubels && (
				<>
					{isText ? (
						<>
							<WMHeading title={title} />
							{wochenmailtUiStore.jubels.map((p, i) => (
								<span key={`${p.anniversaryDate}-${i}`}>
									{p.fullName} ({p.stellenBezeichnung}): {formatDate(p.anniversaryDate)} <br />
								</span>
							))}
							<br />
							<br />
						</>
					) : (
						<WmTableRow>
							<table width={'100%'} style={wmStyles.innerTableStyle}>
								<tbody>
									<tr>
										<td colSpan={2} style={wmStyles.headingTdStyle}>
											<h2 style={{ ...wmStyles.headingStyle, textAlign: 'center' }}>{title}</h2>
										</td>
									</tr>
									{wochenmailtUiStore.jubels.map((p) => (
										<tr key={p.id}>
											<td>
												<strong>{p.fullName}</strong> ({p.stellenBezeichnung})
											</td>
											<td style={{ textAlign: 'right', paddingBottom: '10px' }}>{formatDate(p.anniversaryDate)}</td>
										</tr>
									))}
								</tbody>
							</table>
						</WmTableRow>
					)}
				</>
			)}
		</>
	);
});
